export default __webpack_public_path__ + "static/media/router_info_2x.fc49c0be.webp";